import { render } from "./TextWidget.vue?vue&type=template&id=6aff9959"
import script from "./TextWidget.vue?vue&type=script&lang=js"
export * from "./TextWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__